import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { AppShell } from './navigation/AppShell';
import './theme/global.css';

const container = document.getElementById('root');

if (container === null) throw new Error('No #root element.');

createRoot(container).render(
  <StrictMode>
    {/*
      React Router warned about both future flags on every page load. Opting in now means the behaviour
      is already the v7 behaviour when the major version lands, and — the reason it is worth doing at all
      — the console stops carrying routine noise. A console that always has warnings in it is a console
      nobody reads, and that is where a real network failure appears too (R0123).
    */}
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AppShell />
    </BrowserRouter>
  </StrictMode>,
);
